/* eslint-disable default-case */

import { BillingContent } from "./Content/BillingContent";
import { DashboardContent } from "./Content/DashboardContent";
import { FupQuotaContent } from "./Content/FupQuotaContent";
import { HistoryContent } from "./Content/HistoryContent";
import { ProfileContent } from "./Content/ProfileContent";
import { SKELS } from "./ScheletonBlock";

  export const renderContent = (loading, tabLoading, tab, data, navigate) => {
    if (loading || tabLoading) return SKELS[tab];
    switch(tab) {
      case "dashboard":
        return (
          <DashboardContent
            data={data}
            onNav={navigate}
          />
        );
      case "billing":
        return (
          <BillingContent
          data={data}
          />
        )
      case "history":
        return (
          <HistoryContent
          data={data}
          />
        )
      case "fup":
        return (
          <FupQuotaContent
          data={data}
          />
        )
      case "profile":
        return (
          <ProfileContent
          data={data}
          />
        )
    }
  };
